import "jsondiffpatch/public/formatters-styles/html.css";
import jsondiffpatch from "jsondiffpatch/src/main";
import formatters from "jsondiffpatch/src/main-formatters";
import React from "react";
import ModalWindow from "../../modules/ModalWindow";
import Api from "../../utils/Api";

export class DiffView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      new_config: {},
      old_config: {},
      show_raw: true,
    };

    this.renderNavigation = this.renderNavigation.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.visible !== nextProps.visible && nextProps.visible) {
      this.setState({
        new_config: {},
        old_config: {},
      });
      this.handle_load(nextProps.new_id, nextProps.new_id_device, nextProps.old_id, nextProps.old_id_device);
    }
  }

  handle_load = (new_id, new_device, old_id, old_device) => {
    let self = this;
    Api.get(
      "/managedevice/ajax/device/" + new_device + "/configuration/changes/id/" + new_id + "/full",
      function (current) {
        self.setState({ new_config: JSON.parse(current["result"]["body"]) });
        Api.get(
          "/managedevice/ajax/device/" + old_device + "/configuration/changes/id/" + old_id + "/full",
          function (before) {
            self.setState({ old_config: JSON.parse(before["result"]["body"]) });
          },
          (err) => {
            console.log(err);
          }
        );
      },
      (err) => {
        console.log(err);
      }
    );
  };

  handleHide = () => {
    this.props.handleClose();
  };

  renderActions = () => {
    return (
      <button type="submit" className="mui-btn mui-btn--raised" onClick={this.handleHide}>
        Close
      </button>
    );
  };

  showRaw = (event) => {
    event.preventDefault();
    this.setState({ show_raw: true });
  };

  showDiff = (event) => {
    event.preventDefault();
    this.setState({ show_raw: false });
  };

  renderNavigation = () => {
    return (
      <div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className="nav-link" onClick={this.showRaw}>
          Raw
        </a>{" "}
        | {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className="nav-link" onClick={this.showDiff}>
          Diff
        </a>
      </div>
    );
  };

  render_raw = () => {
    return (
      <div>
        <div className="main-content-sub-element">
          <div className="row">
            <div className="col-md-6">
              <span>
                <b>Before:</b>
              </span>
              <pre>{JSON.stringify(this.state.old_config, null, 2)}</pre>
            </div>
            <div className="col-md-6">
              <span>
                <b>After:</b>
              </span>
              <pre>{JSON.stringify(this.state.new_config, null, 2)}</pre>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render_diff = () => {
    let delta = jsondiffpatch
      .create({
        objectHash: function (obj) {
          let hash = [],
            prop;
          for (prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              hash.push(prop);
            }
          }
          return hash.sort().join("");
        },
      })
      .diff(this.state.old_config, this.state.new_config);
    let content = { __html: formatters.html.format(delta, this.state.old_config) };

    console.log("Generated HTML:", content.__html); // Debug line

    return <div dangerouslySetInnerHTML={content} />;
  };

  render() {
    if (this.props.visible) {
      return (
        <ModalWindow
          title="Configuration Changes"
          handleHide={this.handleHide}
          navigation={this.renderNavigation()}
          actions={this.renderActions()}
          customClass="wide-modal"
        >
          {this.state.show_raw ? this.render_raw() : this.render_diff()}
        </ModalWindow>
      );
    }

    return <div />;
  }
}
